import { provideSingleton } from './inversify';
import { setContextForError } from '../core/system/GlobalErrorCatching';

@provideSingleton(ContextService)
export class ContextService {


    public static changeList: Array<any> = [];
    public static changeCnt = 0;

    constructor() {
        this.set = this.set.bind(this);
        this.get = this.get.bind(this);
    }

    private context: any = {};
    get(key: string): any {
        return this.context[key];
    }
    set(key: string, value: any): void {
        setContextForError(this.context);
        if (this.context[key] !== value) { // Wir loggen nur änderungen
            ContextService.changeCnt++;
            const item = { count: ContextService.changeCnt, key, value };
            // console.log('Context-Change: ', item);
            ContextService.changeList.push(item);

            if (ContextService.changeList.length > 50) {
                ContextService.changeList.shift();
            }
        }
        return this.context[key] = value;
    }
    getObjectKeys() {
        return Object.keys(this.context);
    }
    delete(key: string) {
        delete (this.context[key]);
    }
    clear() {
        this.context = {};
    }
    save() {
        // --> localStorage
    }
    load() {
        // <-- localStorage
    }
}
